// This icon file is generated automatically.
var PPoweroffOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.03.95a.13.13 0 00-.19.11v1c0 .1.05.17.12.22a5.5 5.5 0 012.16 2.55 5.55 5.55 0 01-1.19 6.1 5.52 5.52 0 01-6.1 1.2A5.52 5.52 0 011.44 7a5.55 5.55 0 012.6-4.72.25.25 0 00.13-.21v-1c0-.1-.1-.16-.19-.12a6.76 6.76 0 106.05 0zM6.5 7.75h1c.07 0 .13-.06.13-.13V.38A.13.13 0 007.5.26h-1a.13.13 0 00-.13.13v7.25c0 .06.06.12.13.12z", "fill-rule": "nonzero" } }] }, "name": "p-poweroff", "theme": "outlined" };
export default PPoweroffOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPoweroffOutlined.js
// module id = 3550
// module chunks = 0